import React, { useContext, useMemo } from 'react';
import { I18nContext, I18nProvider } from './context';
export function withI18n(Page, keys) {
    const WithI18nWrapper = ({ i18nMessages = {}, ...rest }) => {
        const { messages: parentMessages, locale } = useContext(I18nContext);
        const mergedMessages = useMemo(() => {
            let merged = i18nMessages;
            if (parentMessages)
                merged = { ...parentMessages, ...i18nMessages };
            return merged;
        }, [i18nMessages, parentMessages]);
        return (React.createElement(I18nProvider, { messages: mergedMessages, locale: locale },
            React.createElement(Page, { ...rest })));
    };
    WithI18nWrapper.i18nKeys = keys;
    WithI18nWrapper.i18nGetMessages = Page.i18nGetMessages;
    return WithI18nWrapper;
}
//# sourceMappingURL=withI18n.js.map